import React, { Component } from "react";

import SubscriptionPlans from "./SubscriptionPlans";
import PriceEstimation from "./PriceEstimation";
import PricingCart from "./PricingCart";
import PricingContainerRight from "./PricingContainerRight";
class MainContainer extends Component {
  render() {
    return (
      <div className="right_col" role="main" >
        
        <div className="clearfix"></div>
        {/* <PriceEstimation /> */}
        <div className="row row-flex pricingPage pricing-expert">
          <SubscriptionPlans />

          <PricingContainerRight />
        </div >
        {/* <PricingCart/> */}
      </div >
    );
  }
}

export default MainContainer;



// WEBPACK FOOTER //
// ./src/components/Pricing/PricingContainer/MainContainer.js